// extracted by mini-css-extract-plugin
export default {"modalContent":"AddEquipment_modalContent__9umHi","footerBtns":"AddEquipment_footerBtns__OlKIK","modal":"AddEquipment_modal__U+lSE","heading":"AddEquipment_heading__UQSj-"};